import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function ProductReveal() {
  const features = ['Scripts de WhatsApp listos para copiar y pegar', 'Sistema de agenda y control de no-shows', 'Planillas y fichas listas para imprimir o usar en celular', 'Adaptado 100% al contexto argentino 2025', 'Documentos legales y consentimientos reales', 'Sin lenguaje técnico — directo y aplicable', 'Listo para usar desde el primer turno'];
  return <section className="py-12 px-4 max-w-5xl mx-auto text-center" data-id="element-277">
      <FadeIn data-id="element-278">
        <div className="inline-block mb-6" data-id="element-279">
          <span className="text-6xl" data-id="element-280">🏆</span>
        </div>
        <h2 className="text-4xl md:text-6xl font-black mb-6 text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-pink-600" data-id="element-281">
          MEGAPACK MANICURISTA LISTA™
        </h2>
        <p className="text-2xl md:text-3xl font-bold text-gray-200 mb-10" data-id="element-282">
          6 Tomos + 6 Bonos · Todo resuelto. Todo argentino. Todo listo.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-283">
        <div className="bg-gray-900/50 border border-pink-900/50 rounded-2xl p-8 max-w-3xl mx-auto text-left" data-id="element-284">
          <ul className="space-y-4" data-id="element-285">
            {features.map((feature, index) => <li key={index} className="flex items-center gap-3" data-id="element-286">
                <CheckCircle2 className="text-pink-500 shrink-0" size={24} data-id="element-287" />
                <span className="text-lg text-gray-200 font-medium" data-id="element-288">
                  {feature}
                </span>
              </li>)}
          </ul>
        </div>
      </FadeIn>
    </section>;
}